import React, { useState } from 'react';
import './ComingSoonModal.css';

interface ComingSoonModalProps {
  isOpen: boolean;
  onClose: () => void;
  darkMode: boolean;
}

const ComingSoonModal: React.FC<ComingSoonModalProps> = ({ isOpen, onClose, darkMode }) => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      // In a real app, this would send the email to your backend
      console.log('Email subscribed:', email);
      setSubscribed(true);
      setTimeout(() => {
        onClose();
        setSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`coming-soon-modal ${darkMode ? 'dark' : ''}`} onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <span className="material-icons">close</span>
        </button>
        
        <div className="modal-content">
          {!subscribed ? (
            <>
              <div className="modal-icon">
                <span className="material-icons">rocket_launch</span>
              </div>
              
              <h2>Exciting Features Coming Soon!</h2>
              
              <div className="features-preview">
                <div className="feature-item">
                  <span className="material-icons">auto_awesome</span>
                  <span>AI-Powered Resume Builder</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">smart_toy</span>
                  <span>Smart Job Matching Algorithm</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">send</span>
                  <span>Automated Job Applications</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">insights</span>
                  <span>Salary Predictions & Negotiations</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">psychology</span>
                  <span>Personalized Career Coach</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">groups</span>
                  <span>Professional Networking Hub</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">school</span>
                  <span>Skill Gap Analysis & Learning</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">trending_up</span>
                  <span>Real-time Market Trend Alerts</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">assessment</span>
                  <span>Career Path Visualization</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">verified</span>
                  <span>Company Culture Insights</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">currency_exchange</span>
                  <span>Cost of Living Calculator</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">business_center</span>
                  <span>Premium Business Accounts</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">filter_alt</span>
                  <span>Advanced Candidate Filtering</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">analytics</span>
                  <span>Employer Analytics Dashboard</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">compare_arrows</span>
                  <span>Multi-Country Comparisons</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">notifications_active</span>
                  <span>Smart Job Alert System</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">workspace_premium</span>
                  <span>Skills & Certifications Tracker</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">timeline</span>
                  <span>Salary Progression Insights</span>
                </div>
              </div>
              
              <p className="modal-description">
                Join the future of job searching! Our upcoming premium features will revolutionize how you 
                navigate your career. From AI-powered tools to advanced analytics, we're building everything 
                you need to make smarter career decisions. Be among the first to experience these innovations!
              </p>
              
              <form onSubmit={handleSubmit} className="notify-form">
                <div className="email-input-group">
                  <span className="material-icons">mail</span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    required
                  />
                </div>
                <button type="submit" className="notify-button">
                  <span className="material-icons">notifications_active</span>
                  Notify Me When It's Ready
                </button>
              </form>
              
              <p className="privacy-note">
                <span className="material-icons">lock</span>
                We respect your privacy. No spam, ever.
              </p>
            </>
          ) : (
            <div className="success-message">
              <span className="material-icons success-icon">check_circle</span>
              <h2>You're on the List!</h2>
              <p>We'll notify you at <strong>{email}</strong> when these features launch.</p>
              <p className="success-note">Get ready to supercharge your job search! 🚀</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ComingSoonModal;